const isoInstant = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})$/

/**
 * Revives instants and leaves numbers as numbers.
 *
 * The shared `parse-json` helper converts every JSON number to `Decimal`, which is correct for
 * money and wrong for statistics: counts and durations are fed to `LineChart`, whose `ChartPoint`
 * is typed `number | null`, and to plain arithmetic when buckets are aggregated. Converting to
 * `Decimal` and back on every bucket of every series costs more than it buys, and a `Decimal`
 * reaching a chart renders as `[object Object]`.
 */
export default function parseStatisticsJson(text: string): any {
  return JSON.parse(text, (_key, value) =>
    typeof value === 'string' && isoInstant.test(value) ? new Date(value) : value,
  )
}
